import styled from 'styled-components'

export const StyledTable = styled('div')`
  table {
      table-layout:fixed;
  }
    
  td.ant-table-cell {
      width: 50%;
  }

  .bold {
      font-weight: bold;
  }
`
